import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import type { PaginationMeta } from '@core/http-types';
import { LocationBrief } from '@core/locations-types';
import { createEffectFactory } from '@core/ngrx-legacy';

import { LocationsByCompanyHttpService } from './locations-by-company-http.service';
import { LocationsByCompanyActions } from './locations-by-company.store';

@Injectable({
  providedIn: 'root',
})
export class LocationsByCompanyEffects {
  private readonly http = inject(LocationsByCompanyHttpService);
  private readonly actions$ = inject(Actions);

  public effects = createEffectFactory(LocationsByCompanyActions, this.actions$);

  public fetch = this.effects(LocationsByCompanyActions.fetchOne, ({ payload }) =>
    this.fetchBriefCollection(<string>payload.id, [], 1).pipe(
      map(response => ({
        data: response,
        id: response.id,
      })),
    ),
  );

  private fetchBriefCollection(
    companyId: string,
    locations: LocationBrief[],
    page: number,
  ): Observable<{ locations: LocationBrief[]; id: string; meta: PaginationMeta }> {
    return this.http.fetchOne$(companyId, page).pipe(
      switchMap(response => {
        const fetchedAll = response.meta.limit * response.meta.page > response.meta.totalCount;
        return fetchedAll
          ? of<{ locations: LocationBrief[]; id: string; meta: PaginationMeta }>({
              ...response,
              locations: [...locations, ...response.locations],
            })
          : this.fetchBriefCollection(
              companyId,
              [...locations, ...response.locations],
              response.meta.page + 1,
            );
      }),
    );
  }
}
